import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'clsx'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'
import SVG from 'react-inlinesvg'

// Redux
import { setSort } from '~lib/saga/filter/actions'
// Components
import { RemoveFilterIcon } from '~2023/components/Icons'
// Styles
import useStyles from './SortByItem.style'
// Utils

const filterSelector = (state) => state.filter

const SortByItem = ({ sortFilter }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const {
    data: { year: filterYear },

    default: { year: defaultYear },
  } = useSelector(filterSelector)

  // @note[todo] a11y + refactor for not 2019
  const handleDeselect = () => {
    dispatch(setSort('rank'))
    filterYear && navigate(defaultYear === filterYear ? '/' : `/${filterYear}`)
  }

  return (
    <div className={cx(classes.sortBySection)}>
      <button
        className={cx(classes.sortByBtn)}
        type="button"
        onClick={() => handleDeselect()}
      >
        <span className={cx(classes.sortByBtnX)}>
          <SVG
            src={RemoveFilterIcon}
            width={10}
            height={10}
            title="Remove Filter"
            description="A checkmark icon that is used to remove Fandom result filtering"
          />
        </span>
        <span className={cx(classes.sortByBtnText)}>
          {'Filtered'} by {sortFilter}
        </span>
      </button>
    </div>
  )
}

SortByItem.propTypes = {
  sortFilter: PropTypes.string.isRequired,
}

export default SortByItem
